module.exports = __webpack_public_path__ + "img/ivTest_sub58.a95a00f0.jpg";